import { Phone, Mail, Clock } from "lucide-react";
import FadeUp from "../components/site/FadeUp";
import QuoteForm from "../components/site/QuoteForm";
import { CONTACT } from "../data/site";
import { track, EVENTS } from "../lib/analytics";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="section-pad">
        <div className="container-hh grid items-start gap-12 lg:grid-cols-2">
          <FadeUp>
            <p className="eyebrow">Get in touch</p>
            <h1 className="mt-3 text-4xl md:text-5xl lg:text-6xl">
              We'd love to hear from you.
            </h1>
            <p className="mt-5 max-w-md text-lg leading-relaxed text-bodytext">
              Questions, quotes, or just curious whether we're the right fit?
              Send a note or reach out directly — Sarah follows up within 24
              hours.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href={CONTACT.phoneHref}
                data-testid="contact-phone"
                onClick={() => track(EVENTS.CALL_CLICK, { location: "contact" })}
                className="flex items-center gap-4 rounded-[12px] bg-white p-5 shadow-cozy transition-shadow hover:shadow-cozy-lg"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-seafoam">
                  <Phone className="h-5 w-5 text-teal" />
                </span>
                <span>
                  <span className="block text-sm text-bodytext/70">Call or text</span>
                  <span className="font-semibold text-navy">{CONTACT.phone}</span>
                </span>
              </a>
              <a
                href={CONTACT.emailHref}
                data-testid="contact-email"
                className="flex items-center gap-4 rounded-[12px] bg-white p-5 shadow-cozy transition-shadow hover:shadow-cozy-lg"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-seafoam">
                  <Mail className="h-5 w-5 text-teal" />
                </span>
                <span>
                  <span className="block text-sm text-bodytext/70">Email us</span>
                  <span className="font-semibold text-navy">{CONTACT.email}</span>
                </span>
              </a>
              <div className="flex items-center gap-4 rounded-[12px] bg-seafoam p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white">
                  <Clock className="h-5 w-5 text-teal" />
                </span>
                <span className="text-sm font-medium text-navy">
                  We respond within 24 hours, every time.
                </span>
              </div>
            </div>
          </FadeUp>

          <FadeUp delay={0.1}>
            <QuoteForm
              heading="Send us a message"
              submitLabel="Send Message"
              type="contact"
            />
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
